<template>
    <div
        class="notification-popup"
        :class="[
            `notification-popup--${theme}`,
            { 'notification-popup--image': isImageVariant },
            { 'notification-popup--fade-out': isClosing },
        ]"
        ref="notification"
        @touchstart="touchStart"
        @touchend="touchEnd"
        role="status"
        aria-live="polite"
    >
        <WebpImage
            v-if="imageUrl"
            :src="imageUrl"
            alt=""
            :css-class="['notification-popup__image', { 'notification-popup__image--big': isImageVariant }]"
            class="notification-popup__picture"
            :class="{ 'notification-popup__picture--big': isImageVariant }"
        />
        <div class="notification-popup__text">
            <div class="notification-popup__title">
                {{ title }}
            </div>
            <div class="notification-popup__description" v-if="description" v-html="description"></div>
        </div>
        <button class="notification-popup__close" @click="closeNotification" aria-label="Zavřít notifikaci"></button>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import NotificationPopupProps from "./notification-popup-props";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const emit = defineEmits(["destroyPopup"]);

const props = withDefaults(defineProps<NotificationPopupProps>(), {
    variant: "icon",
    imageUrl: "/frontend/web/img/notifications/prize.svg",
    theme: "light",
    autoCloseDuration: 10000,
});

const notification = ref<HTMLElement>(null);
let fadeOutDuration = 0;

const isClosing = ref(false);
const isImageVariant = props.variant === "image";

let touchStartY = 0;
let touchEndY = 0;

const closeNotification = () => {
    isClosing.value = true;

    setTimeout(() => {
        emit("destroyPopup");
    }, fadeOutDuration);
};

const touchStart = (event: TouchEvent) => {
    // prevent scrolling page through element
    event.preventDefault();
    touchStartY = event.changedTouches[0].screenY;
};

const touchEnd = (event: TouchEvent) => {
    touchEndY = event.changedTouches[0].screenY;

    const swipeDistance = Math.abs(touchStartY - touchEndY);

    if (touchEndY < touchStartY && swipeDistance > 10) {
        closeNotification();
    }
};

onMounted(() => {
    // get fadeOutDuration value from css variable
    fadeOutDuration = parseInt(getComputedStyle(notification.value).getPropertyValue("--fade-out-duration"));

    if (props.autoCloseDuration) {
        setTimeout(closeNotification, props.autoCloseDuration);
    }
});
</script>
